import React, { useEffect, useRef, useState } from "react";
import allImgPaths from "assets/images";
import EmptyReviewSpace from "components/reviewspace/EmptyReviewSpace";
import PinnedReviewSpace from "components/reviewspace/PinnedReviewSpace";
import ReviewSpaceTaskButton from "./ReviewSpaceTaskButton";
import ReviewEventVenueCard from "./ReviewEventVenueCard";
import ReviewEventProgramCard from "./ReviewEventProgramCard";
import { addHistoryData, getInsightData } from "services/event";
import { useParams } from "react-router-dom";
import useAppState from "context/useAppState";
import ReviewContentCard from "./ReviewContentCard";
import { cloneDeep } from "lodash";
import { jsonToMarkdown } from "utils/function";
import { getLLMAgentRAGDeletePayload, getLLMAgentRAGUpdatePayload } from "services/llm/payloads";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ExistingSettingMemberLoader } from "components/loaders";
import Toast from "components/common/Toast";
import Loader from "components/Loader";
import ConfirmationModal from "components/common/modal/ConfirmationModal";
import { REVIEW_SPACE_ACTIONS } from "utils/constant";
import { format } from "date-fns";
import { pinTaskData } from "services/chat";
import BudgetCard from "./BudgetCard";
import RFPCard from "./RFPCard";
import EmailTemplateCard from "./EmailTemplateCard";
import FileUploadCard from "./FileUploadCard";
import LogisticsCard from "./LogisticsCard";

const ReviewSpace = ({ blockId, callFromBoard = false, closeBoard, blockName = null }: any) => {
  const { id: eventId } = useParams();
  const { selectedCardDetail, updateBoardCallApiFlag } = useAppState("cardWrapper");

  const { block_id = blockId, _id: cardId } = selectedCardDetail || {};
  const [insightData, setInsightData] = useState<any[]>([])
  const { setState: setEventState, isInsightCallApi, sendButtonRef } = useAppState('eventData')

  const { updateMessageContent, deleteMessage } = useAppState('chatMessages')
  const { updateRAGEntryOfFete, deleteRAGEntryOfFete } = useAppState('chatBox')

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteData, setDeleteData] = useState<any>({})

  const [loading, setLoading] = useState<boolean>(false);

  const { setState: setEventDataState } = useAppState("eventData");

  const { cards: cardList, fetchCardPrompt, fetchChipData, setState: setCardWrapperState, updateCardSelectedState, columns } = useAppState("cardWrapper");
  const { setState: setChatBoxState } = useAppState("chatBox");

  useEffect(() => {
    if (isInsightCallApi || blockId) {
      fetchData()
    }
  }, [isInsightCallApi, blockId])

  const fetchData = async () => {
    // console.log({ eventId, block_id, cardId })
    if (eventId && block_id) {

      let insightPayload: any = { blockId: block_id }
      if (cardId) insightPayload = { ...insightPayload, cardId }

      setLoading(true);
      const { data } = await getInsightData(eventId, insightPayload)

      const updatedData = addActions(data)
      setInsightData(updatedData);
      setEventState({ isInsightCallApi: false })
      setLoading(false);

      console.log({ insightData: updatedData, cardName: selectedCardDetail })
    } else {
      // console.log('Event or block id is undefined')
      setLoading(false);
    }
  }

  const addActions = (data: any[]) => {
    const reviewSpaceActions = REVIEW_SPACE_ACTIONS;
    data.map((dt: any, dtIndex: number) => {
      const actions = reviewSpaceActions.find((rs: any) => dt.cardName.toLowerCase() == rs.card.toLowerCase())?.tasks.find((task: any) => dt.taskName.toLowerCase() == task.name.toLowerCase())
      if (actions) dt['actions'] = actions;

      // Add random messageId
      if (dt?.content?.length) {
        dt.content.map((dc: any, dcIndex: number) => {
          dc['newMessageId'] = dc.messageId + Date.now() + dtIndex + dcIndex;
          dc['updatedTime'] = dc?.updatedAt ? format(dc?.updatedAt, "MMMM d, yyyy h:mm a") : 'N/A'
        })
      }
    })

    return data
  }

  const deleteItemModal = (ids: any, title: string) => {
    setShowDeleteModal(true)
    setDeleteData({ ids, title })
  }

  const confirmDelete = () => {
    if (deleteData && Object.keys(deleteData).length) {
      const { ids, title } = deleteData
      deleteItem(ids, title)
    }
  }

  const deleteItem = async (ids: any, title: string) => {
    const { messageId, taskId } = ids
    if (taskId) {
      // Get the data for the current taskId
      const taskData = insightData.find((idt: any) => JSON.stringify(idt.taskId) == JSON.stringify(taskId))
      const taskDataIndex = insightData.findIndex(idt => JSON.stringify(idt.taskId) == JSON.stringify(taskId))
      if (taskData) {
        // const taskDataIndex = (taskData?.content || []).findIndex((idt: any) => JSON.stringify(idt.messageId) == JSON.stringify(messageId))
        // Get content of the selected messageId
        const taskContent = (taskData?.content || []).filter((tc: any) => JSON.stringify(tc.messageId) == JSON.stringify(messageId));
        if (taskContent?.length) {
          // Get filtered content other than the selected one so that, that one can be removed and others only remains
          const finalContent = taskData?.isRichTextContent
            ? taskData?.content?.filter((tc: any) => JSON.stringify(tc.messageId) != JSON.stringify(taskContent[0].messageId))
            : taskContent.filter((td: any) => td.title != title);

          const removalItemMessageId = taskContent.find((td: any) => td.title == title)?.newMessageId;

          // Call History API
          let taskTitle;
          let taskType;
          const changedContent = taskContent.find((tc: any) => tc.title == title);
          if (changedContent?.isRichTextContent) {
            taskTitle = 'isRichTextContent';
            taskType = 'isRichTextContent'
          }
          else if (changedContent?.isEmailContent) {
            taskTitle = 'isEmailContent';
            taskType = 'isEmailContent'
          }
          else if (changedContent?.isRFP) {
            taskTitle = 'isRFP';
            taskType = 'isRFP'
          } else {
            taskTitle = title;
            taskType = 'items'
          }
          const addHistoryPayload = {
            ragId: changedContent.ragId,
            // taskTitle: changedContent?.isRichTextContent ? 'isRichTextContent' : (changedContent?.isEmailContent ? 'isEmailContent' : title),
            // taskType: changedContent?.isRichTextContent ? 'isRichTextContent' : (changedContent?.isEmailContent ? 'isEmailContent' : 'items'),
            taskTitle,
            taskType,
            actionType: 'isDelete',
            itemData: changedContent
          }
          // console.log({ addHistoryPayload })
          await addHistoryData(addHistoryPayload)

          await callAPIs(taskData, finalContent, taskId, messageId, taskDataIndex, taskData?.isRichTextContent ? true : false, removalItemMessageId, false)
        }
      }
    }
  }

  const setItemIsFavorite = async (ids: any, title: string, value: boolean) => {
    const { messageId, taskId } = ids
    if (taskId) {
      const taskData = insightData.find((idt: any) => JSON.stringify(idt.taskId) == JSON.stringify(taskId))
      const taskDataIndex = insightData.findIndex(idt => JSON.stringify(idt.taskId) == JSON.stringify(taskId))
      if (taskData) {
        // const taskDataIndex = (taskData?.content || []).findIndex((idt: any) => JSON.stringify(idt.messageId) == JSON.stringify(messageId))
        const taskContent = (taskData?.content || []).filter((tc: any) => JSON.stringify(tc.messageId) == JSON.stringify(messageId));
        taskContent.map((td: any) => {
          if (td.title == title) td['is_favorite'] = value
        });

        const favoriteItemMessageId = taskContent.find((td: any) => td.title == title).newMessageId

        // Call History API
        const changedContent = taskContent.find((tc: any) => tc.title == title);
        const addHistoryPayload = {
          ragId: changedContent.ragId,
          taskTitle: title,
          taskType: 'items',
          actionType: 'isFavorite',
          isFavorite: changedContent.is_favorite
        }
        await addHistoryData(addHistoryPayload)

        await callAPIs(taskData, taskContent, taskId, messageId, taskDataIndex, false, favoriteItemMessageId, true)
      }
    }
  }

  const setEditorItemIsFavorite = async (ids: any, title: string, value: boolean) => {
    const { messageId, taskId } = ids;
    if (taskId) {
      const taskData = insightData.find((idt: any) => JSON.stringify(idt.taskId) == JSON.stringify(taskId))
      const taskDataIndex = insightData.findIndex(idt => JSON.stringify(idt.taskId) == JSON.stringify(taskId))
      if (taskData) {
        const taskContent = (taskData?.content || []).filter((tc: any) => JSON.stringify(tc.messageId) == JSON.stringify(messageId));
        taskContent.map((td: any) => {
          if (td.title == title) td['is_favorite'] = value
        });

        handleRAGCallForEditor(taskId, messageId, taskContent[0], value)
      }
    }
  }

  const callAPIs = async (taskData: any, taskContent: any, taskId: any, messageId: any, taskDataIndex: any, isRichTextContent: boolean, newMessageId: any, fromFavorite = false) => {
    if (taskContent?.length) {
      let contentPayload: any = {}
      let items = []
      let ragItems = []

      if (taskContent[0]?.heading) {
        items = taskContent.map(({ title, description, selected, is_favorite, is_pinned }: any) => ({
          title,
          description,
          selected,
          is_pinned,
          is_favorite: is_favorite !== undefined ? is_favorite : false
        })) || []
        contentPayload = { ...contentPayload, heading: taskContent[0].heading, items }

        ragItems = cloneDeep(contentPayload.items?.filter((ci: any) => ci?.selected))
        ragItems.map((fc: any) => {
          delete fc['selected']
        })
      }

      if (taskContent[0]?.renderImages) {
        items = taskContent.map(({ title, description, selected, tags, is_favorite, is_pinned }: any) => ({
          title,
          imageDescription: description,
          selected,
          is_pinned,
          tags, selectedTags: tags,
          is_favorite: is_favorite !== undefined ? is_favorite : false
        })) || []
        contentPayload = { ...contentPayload, renderImages: true, items }

        ragItems = cloneDeep(contentPayload.items?.filter((ci: any) => ci?.selected))
        ragItems.map((fc: any) => {
          fc['tags'] = (fc['selectedTags'] || []).filter((st: any) => st)
          delete fc['selectedTags']
          if (fc?.imageDescription) delete fc.imageDescription
          delete fc['selected']
          if (fc?.description) delete fc.description;
          if (fc?.imageUrl) delete fc.imageUrl
          if (fc?.type == 'crawled') {
            delete fc.type
            delete fc.tags;
          }
        })
      }

      const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)
      const messagePayload = {
        content: JSON.stringify(contentPayload),
        teamId: currentTeam?.currentTeamId,
        eventId: eventId,
        is_draft: false,
        taskId: taskId,
        cardId: cardId || taskData?.cardId,
        blockId: block_id
      }

      // Update in DocDB
      setShowDeleteModal(false)  // Close delete modal
      try {
        if (isRichTextContent) {
          await deleteMessage(messageId)
        } else {
          await updateMessageContent(messageId, messagePayload)
        }
        reRenderInsightData(taskContent, taskDataIndex, newMessageId)
      } catch (error) {
        if (!fromFavorite) handleApiCases(false)
      }

      if (!fromFavorite) handleApiCases(true) // Hide loader and show toast

      // Update RAG Data
      if (isRichTextContent) {
        deleteRAGEntryOfFete(getLLMAgentRAGDeletePayload({ index_name: 'feteboard', document_id: messageId }))
      } else {
        await handleRAGCall({ items: ragItems }, taskId, messageId, taskData);
      }

    } else {
      // Nothing left in this rag, so delete rag and delete from docdb as well
      setShowDeleteModal(false)  // Close delete modal

      try {
        await deleteMessage(messageId)
        reRenderInsightData([], taskDataIndex, newMessageId)
      } catch (error) {
        if (!fromFavorite) handleApiCases(false)
      }

      try {
        await deleteRAGEntryOfFete(getLLMAgentRAGDeletePayload({ index_name: 'feteboard', document_id: messageId }))
      } catch (err) {
        console.log({ err })
        return null
      }

      if (!fromFavorite) handleApiCases(true) // Hide loader and show toast
    }
  }

  const handleRAGCall = async (content: any, taskId: any, messageId: any, taskData: any) => {
    const userData = JSON.parse(localStorage.getItem('userData') as string)
    const userEmail = localStorage.getItem('userEmail')
    const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)

    let ragPayload: any = {
      text_content: jsonToMarkdown(content),
      text_prefix: `The current selected or chosen items for ${taskData.taskName} are: `
    }

    const ragMetaData = {
      userId: userData?.id,
      userEmail: userEmail,
      teamId: currentTeam?.currentTeamId,
      eventId: eventId,
      is_draft: false,
      taskId: taskId,
      updatedAt: new Date().toISOString(),
      cardId: selectedCardDetail?._id || taskData?.cardId
    }

    ragPayload = { ...ragPayload, document_path: messageId, additional_metadata: ragMetaData }

    try {
      await updateRAGEntryOfFete(getLLMAgentRAGUpdatePayload(ragPayload))
    } catch (err) {
      console.log({ err })
      return null
    }
  }

  const handleRAGCallForEditor = async (taskId: any, messageId: any, taskData: any, isFavorite: boolean) => {
    const userData = JSON.parse(localStorage.getItem('userData') as string)
    const userEmail = localStorage.getItem('userEmail')
    const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)

    let ragPayload: any = {
      text_prefix: jsonToMarkdown({ heading: taskData?.title ? taskData.title : '' }),
      text_content: jsonToMarkdown({ content: taskData.text, is_favorite: isFavorite })
    }

    const ragMetaData = {
      userId: userData?.id,
      userEmail: userEmail,
      teamId: currentTeam?.currentTeamId,
      eventId: eventId,
      is_draft: false,
      taskId: taskId,
      updatedAt: new Date().toISOString(),
      cardId: selectedCardDetail?._id || taskData?.cardId
    }

    ragPayload = { ...ragPayload, document_path: messageId, additional_metadata: ragMetaData }

    try {
      await updateRAGEntryOfFete(getLLMAgentRAGUpdatePayload(ragPayload))
    } catch (err) {
      console.log({ err })
      return null
    }
  }

  const handleApiCases = (isSuccess: boolean) => {
    Loader({ isLoading: false })
    if (isSuccess) {
      Toast.success('Task Update', 'Successfully updated task')
    } else {
      Toast.error('Task Update', 'Failed to update task')
    }
  }

  const reRenderInsightData = (taskContent: any[], taskDataIndex: any, newMessageId: any) => {
    setEventState({ isInsightCallApi: true })

    // console.log({ taskContent, taskDataIndex, newMessageId })

    // const updatedContentData = taskContent.find((tc: any) => JSON.stringify(tc.newMessageId) == JSON.stringify(newMessageId))
    // console.log({ updatedContentData })
    // console.log({ insightData })

    // let updatedInsightData = cloneDeep(insightData).map((item: any, index: number) => {
    //   if (index === taskDataIndex) {
    //     let mainContent: any[] = cloneDeep(item.content || []);
    //     console.log({ mainContent })

    //     if (!taskContent?.length) {
    //       const removalIndex = mainContent.findIndex((mc: any) => JSON.stringify(mc.newMessageId) == JSON.stringify(newMessageId))
    //       console.log({ removalIndex })
    //       if (removalIndex > -1) {
    //         mainContent.splice(removalIndex, 1)
    //       }
    //     } else {
    //       if (updatedContentData) {
    //         mainContent.map((obj: any) => (JSON.stringify(obj.newMessageId) == JSON.stringify(newMessageId) ? updatedContentData : obj));
    //       } else {
    //         const removalIndex = mainContent.findIndex((mc: any) => JSON.stringify(mc.newMessageId) == JSON.stringify(newMessageId))
    //         console.log({ removalIndex })
    //         if (removalIndex > -1) {
    //           mainContent.splice(removalIndex, 1)
    //         }
    //       }
    //     }

    //     return { ...item, content: mainContent }
    //   }

    //   return item
    // })

    // // Filter out card data which has no tasks left
    // updatedInsightData = updatedInsightData.filter((item, index) => item?.content.length > 0);

    // console.log({ final: updatedInsightData })

    // const updatedData = addActions(updatedInsightData)
    // setInsightData(updatedData)
  }

  const editItem = async (ids: any, title: string) => {
    const { messageId, taskId } = ids;
    const taskData = insightData.find((idt: any) => JSON.stringify(idt.taskId) == JSON.stringify(taskId))
    // console.log({ taskData })
    if (taskData) {
      let taskContent = (taskData?.content || []).filter((tc: any) => JSON.stringify(tc.messageId) == JSON.stringify(messageId));
      // console.log({ taskContent })

      if (taskContent?.length) {
        if (taskData?.isRichTextContent) {
          const richTextEditorContent = {
            isRichTextContent: true,
            taskId: taskId,
            // content: taskContent[0].text, is_favorite: taskContent[0].is_favorite || false,
            title: taskContent[0].title || '',
            content: { messageId: taskData?.content?.[0]?.messageId, ragId: taskData?.content?.[0]?.ragId, newMessageId: taskData?.content?.[0]?.messageId + Date.now(), items: taskContent[0].content || [] },
            isEditMode: true
          }
          const richTextEditorData = { _id: taskContent[0].messageId, content: JSON.stringify(richTextEditorContent), type: "ai" }

          setEventDataState({ showReviewSpace: false, callFromEmptyReviewSpace: true, insightEditData: [richTextEditorData] })
        }

        if (taskData?.isEmailContent) {
          const emailEditorContent = {
            isEmailContent: true,
            taskId: taskId,
            isEditMode: true,
            title: taskContent[0].title || '',
            content: { messageId: taskData?.content?.[0]?.messageId, ragId: taskData?.content?.[0]?.ragId, newMessageId: taskData?.content?.[0]?.messageId + Date.now(), items: taskContent[0].content || [] },
            // content: { ...taskContent[0].text, isEditMode: true }
          }
          const emailEditorData = { _id: taskContent[0].messageId, newMessageId: taskContent[0].messageId + Date.now(), content: JSON.stringify(emailEditorContent), type: "ai" }

          setEventDataState({ showReviewSpace: false, callFromEmptyReviewSpace: true, insightEditData: [emailEditorData] })
        }

        if (taskData?.isBudgetAllocation) {
          const budgetAllocationContent = {
            isBudgetAllocation: true,
            taskId: taskId,
            isViewMode: false,
            content: { messageId: taskData?.content?.[0]?.messageId, ragId: taskData?.content?.[0]?.ragId, isEditMode: true, newMessageId: taskData?.content?.[0]?.messageId + Date.now() }
          }
          const budgetEditorData = { _id: taskData?.content?.[0]?.messageId, newMessageId: taskData?.content?.[0]?.messageId + Date.now(), content: JSON.stringify(budgetAllocationContent), type: "ai" }

          setEventDataState({ showReviewSpace: false, callFromEmptyReviewSpace: true, insightEditData: [budgetEditorData] })
        }

        if (taskData?.isVendorVenueCard && taskContent?.[0]?.isRFP) {
          const rfpContent = {
            isRFP: true,
            taskId: taskId,
            isEditMode: true,
            title: taskContent[0].title || '',
            categories: taskContent[0]?.categories || [],
            content: { messageId: taskContent[0].messageId, ragId: taskData?.content?.[0]?.ragId, newMessageId: taskContent[0].messageId + Date.now(), items: taskContent[0].content || [] },
          }
          const rfpEditorData = { _id: taskContent[0].messageId, newMessageId: taskContent[0].messageId + Date.now(), content: JSON.stringify(rfpContent), type: "ai" }
          setEventDataState({ showReviewSpace: false, callFromEmptyReviewSpace: true, insightEditData: [rfpEditorData] })
        }

        if (taskData?.isFileUpload) {
          const rfpContent = {
            isViewListItem: true,
            category: 'attendee-list',
            file_name: taskContent[0]?.filename || null,
            isEditMode: true,
            content: { messageId: taskData?.content?.[0]?.messageId, ragId: taskData?.content?.[0]?.ragId, newMessageId: taskData?.content?.[0]?.messageId + Date.now(), items: [] },
          }
          const rfpEditorData = { _id: taskData?.content?.[0]?.messageId, newMessageId: taskData?.content?.[0]?.messageId + Date.now(), content: JSON.stringify(rfpContent), type: "ai" }
          setEventDataState({ showReviewSpace: false, callFromEmptyReviewSpace: true, insightEditData: [rfpEditorData] })
        }

        if (taskData?.renderImages && !taskData?.isRFP) {
          const feteItems = cloneDeep(taskContent.map((tc: any) => {
            let items: any = {}
            items = {
              ...items,
              title: tc.title,
              showCheckBox: false,
              isHidden: tc?.title == title ? false : true,
              selected: true,
              imageUrl: tc?.imageUrl,
              is_favorite: tc?.is_favorite || false,
              ragId: tc?.ragId
            }

            if (tc?.tags) {
              items = { ...items, tags: tc.tags, selectedTags: tc.tags, imageDescription: tc.description }
            } else {
              items = { ...items, description: tc.description }
            }

            return items;
          }))

          const dataContent = { renderImages: true, taskId: taskId, items: feteItems, isEdit: true }
          const feteData = { _id: taskContent[0].messageId, newMessageId: taskContent[0].messageId + Date.now(), content: JSON.stringify(dataContent), type: "ai" }

          setEventDataState({ showReviewSpace: false, callFromEmptyReviewSpace: true, insightEditData: [feteData] })
        }

        if (callFromBoard) {
          await handleOnSelectCard(taskData?.cardId)
        }

      }
    }
  }

  const handleOnSelectCard = async (cardId: any) => {
    const chipsData = await fetchChipData(cardId);
    const card = (cardList || []).find((cl: any) => JSON.stringify(cl._id) == JSON.stringify(cardId))

    const blockIndex = (columns || []).findIndex((cl: any) => JSON.stringify(cl.id) == JSON.stringify(block_id))
    closeBoard({ blockIndex, selectedCardId: card._id })

    setCardWrapperState({ chipsData, cardAnimation: true, openCardAnimation: true, selectedCardDetail: card })
    setEventDataState({ openPlanningAnimation: false, showChatbox: true, showReviewSpace: false, showInsight: false })
    sendButtonRef.current = true;

    setTimeout(() => {
      let getPlanningBoard = document.getElementById("planning-board-scroll-top");
      if (getPlanningBoard) {
        setTimeout(() => {
          updateCardSelectedState(card._id, { isSelected: true });
          setCardWrapperState({
            chipsData,
            cardAnimation: true,
            openCardAnimation: true,
            selectedCardDetail: card,
            selectedCardIndex: cardList?.indexOf(card)
          })
        }, 300);
        getPlanningBoard.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
        initChatWithPrompt(card)
      }
    }, 300);
  }

  const initChatWithPrompt = (card: any) => {
    (async () => {
      const prompt = await fetchCardPrompt(card?.prompt_id);
      if (prompt?.name) {
        setChatBoxState({ cardPrompt: prompt })
      }
    })()
  }

  const openFeteFromBoard = async (actionText: any, cardId: any, isBrainstorm: boolean) => {
    const chipsData = await fetchChipData(cardId);
    const card = (cardList || []).find((cl: any) => JSON.stringify(cl._id) == JSON.stringify(cardId))

    const blockIndex = (columns || []).findIndex((cl: any) => JSON.stringify(cl.id) == JSON.stringify(block_id))
    closeBoard({ blockIndex, selectedCardId: card._id })

    setCardWrapperState({ chipsData, cardAnimation: true, openCardAnimation: true, selectedCardDetail: card })
    // setEventDataState({ openPlanningAnimation: false, showChatbox: true, showReviewSpace: true, showInsight: false, isInsightCallApi: true, callFromEmptyReviewSpace: true })
    if (isBrainstorm) {
      setEventDataState({
        openPlanningAnimation: false,
        showChatbox: true,
        showInsight: false
      })
    } else {
      setEventDataState({
        openPlanningAnimation: false,
        showChatbox: true,
        showReviewSpace: true,
        showInsight: false,
        isInsightCallApi: true,
        callFromEmptyReviewSpace: true
      })
    }

    setTimeout(() => {
      let getPlanningBoard = document.getElementById("planning-board-scroll-top");
      if (getPlanningBoard) {
        setTimeout(() => {
          updateCardSelectedState(card._id, { isSelected: true });
          setCardWrapperState({
            chipsData,
            cardAnimation: true,
            openCardAnimation: true,
            selectedCardDetail: card,
            selectedCardIndex: cardList?.indexOf(card)
          })
        }, 300);
        getPlanningBoard.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
        // initChatWithPrompt(card)
      }
    }, 300);
  }

  const downloadItem = async (html: any) => {
    // const doc = new jsPDF();
    // const formattedContent = html.replace(/<br\s*\/?>/gi, '\n'); // Replace `<br>` with newline characters for better formatting

    // doc.html(html, {
    //   callback: (pdf) => {
    //     pdf.save('your-filename.pdf'); // Set the desired filename
    //   },
    // });
  }

  const unPinTaskData = async (ragId: any, payload: any) => {
    await pinTaskData(ragId, payload)

    // Call API again from board when unpinning
    if (callFromBoard) {
      setEventState({ isInsightCallApi: true, blockId: blockId })
    }
  }

  return (
    <>
      {
        showDeleteModal &&
        <ConfirmationModal
          headerText={'Delete'}
          bodyText={``}
          setShowDeleteModal={setShowDeleteModal} confirmDelete={confirmDelete}
        />
      }

      <div className={`${(insightData?.length == 0) ? "h-full" : "h-auto"} review-space-screen relative px-3 py-3 ${(!loading && callFromBoard && insightData?.length == 0) ? "bg-white" : ""}`}>
        <div className=''>
          {loading && <ExistingSettingMemberLoader />}
          {
            !loading && insightData?.length > 0 && insightData.map((item: any, index: number) => (
              <React.Fragment key={index}>
                <div className={`bg-[#F9FAFB] rounded-lg py-4 px-2.5 ${(item?.isRichTextContent) ? "w-full" : "w-full"} `}>
                  {
                    item?.content?.length > 0 &&
                    <>
                      {
                        !item?.renderImages && !item?.isRFP && !item.isVendorVenueCard &&
                        <ReviewSpaceTaskButton
                          taskName={item.taskName}
                          count={item?.content?.length || 0}
                          isCompleted={item.isTaskCompleted}
                        />
                      }
                    </>
                  }
                  {
                    item?.isNormalText &&
                    <div className={`px-2 py-2 gap-x-4 flex pb-7 ${callFromBoard ? "w-[calc(100vw_-_172px)]" : "w-[calc(100vw_-_558px)]"} overflow-x-auto on-hover-show-scrollbar`}>
                      {
                        item?.content?.length > 0 && item.content.map((content: any, contentIndex: number) => (
                          <React.Fragment key={contentIndex}>
                            {/* Add img and pin it - done */}
                            <ReviewContentCard
                              taskId={item.taskId}
                              data={content}
                              deleteItem={deleteItemModal}
                              setItemIsFavorite={setItemIsFavorite}
                              actions={item.actions}
                              unPinTaskData={unPinTaskData}
                              callFromBoard={callFromBoard}
                            />
                          </React.Fragment>
                        ))
                      }
                    </div>
                  }
                  {
                    (item?.renderImages && !item?.isVendorVenueCard) &&
                    <>
                      {
                        item?.content?.filter((ic: any) => ic.renderImages)?.length > 0 &&
                        <ReviewSpaceTaskButton
                          taskName={item.taskName}
                          count={item?.content.filter((ic: any) => ic.renderImages)?.length || 0}
                          isCompleted={item.isTaskCompleted}
                        />
                      }

                      <div className={`px-2 py-2 gap-x-4 flex pb-7 ${callFromBoard ? "w-[calc(100vw_-_172px)]" : "w-[calc(100vw_-_558px)]"} overflow-x-auto on-hover-show-scrollbar`}>
                        {
                          item?.content?.length > 0 && item.content.map((content: any, contentIndex: number) => (
                            <React.Fragment key={contentIndex}>
                              {
                                content?.renderImages &&
                                <ReviewEventVenueCard
                                  taskId={item.taskId}
                                  data={content}
                                  deleteItem={deleteItemModal}
                                  editItem={editItem}
                                  setItemIsFavorite={setItemIsFavorite}
                                  actions={item.actions}
                                  unPinTaskData={unPinTaskData}
                                  callFromBoard={callFromBoard}
                                />
                              }
                            </React.Fragment>
                          ))
                        }
                      </div>
                    </>
                  }
                  {
                    (item?.isRichTextContent) &&
                    <div className={`px-2 py-2 gap-x-4 flex pb-7 ${callFromBoard ? "w-[calc(100vw_-_172px)]" : "w-[calc(100vw_-_558px)]"} overflow-x-auto on-hover-show-scrollbar`}>
                      {
                        item?.content?.length && item.content.map((content: any, contentIndex: number) => (
                          <React.Fragment key={contentIndex}>
                            <ReviewEventProgramCard
                              taskId={item.taskId}
                              data={content}
                              deleteItem={deleteItemModal}
                              editItem={editItem}
                              downloadItem={downloadItem}
                              actions={item.actions}
                              setEditorItemIsFavorite={setEditorItemIsFavorite}
                              unPinTaskData={unPinTaskData}
                              callFromBoard={callFromBoard}
                            />
                          </React.Fragment>
                        ))
                      }
                    </div>
                  }
                  {/* {
                    (item?.isEmailContent) &&
                    <div className={`px-2 py-2 gap-x-4 flex ${callFromBoard ? "w-[calc(100vw_-_172px)]" : "w-[calc(100vw_-_558px)]"} overflow-x-auto`}>
                      {
                        item?.content?.length && item.content.map((content: any, contentIndex: number) => (
                          <React.Fragment key={contentIndex}>
                            <EmailContentCard
                              taskId={item.taskId}
                              data={content}
                              deleteItem={deleteItemModal}
                              editItem={editItem}
                              actions={item.actions}
                              unPinTaskData={unPinTaskData}
                              callFromBoard={callFromBoard}
                            />
                          </React.Fragment>
                        ))
                      }
                    </div>
                  } */}
                  {
                    (item?.isEmailContent) &&
                    <div className={`px-2 py-2 gap-x-4 flex pb-7 ${callFromBoard ? "w-[calc(100vw_-_172px)]" : "w-[calc(100vw_-_558px)]"} overflow-x-auto on-hover-show-scrollbar`}>
                      {
                        item?.content?.length && item.content.map((content: any, contentIndex: number) => (
                          <React.Fragment key={contentIndex}>
                            <EmailTemplateCard
                              taskId={item.taskId}
                              data={content}
                              deleteItem={deleteItemModal}
                              editItem={editItem}
                              actions={item.actions}
                              unPinTaskData={unPinTaskData}
                              callFromBoard={callFromBoard}
                            />
                          </React.Fragment>
                        ))
                      }
                    </div>
                  }
                  {
                    (item?.isBudgetAllocation) &&
                    <div className={`px-2 py-2 gap-x-4 flex pb-7 ${callFromBoard ? "w-[calc(100vw_-_172px)]" : "w-[calc(100vw_-_558px)]"} overflow-x-auto on-hover-show-scrollbar`}>
                      {
                        item?.content?.length && item.content.map((content: any, contentIndex: number) => (
                          <React.Fragment key={contentIndex}>
                            {/* Add img and pin it */}
                            <BudgetCard
                              taskId={item.taskId}
                              data={content}
                              deleteItem={deleteItemModal}
                              editItem={editItem}
                              actions={item.actions}
                              unPinTaskData={unPinTaskData}
                              callFromBoard={callFromBoard}
                            />
                          </React.Fragment>
                        ))
                      }
                    </div>
                  }
                  {/* {
                    (item?.isRFP) &&
                    <div className="mt-5">
                      {
                        item?.content?.filter((ic: any) => ic.isRFP)?.length > 0 &&
                        <ReviewSpaceTaskButton
                          taskName={'RFP'}
                          count={item?.content.filter((ic: any) => ic.isRFP).length || 0}
                          isCompleted={item.isTaskCompleted}
                        />
                      }

                      <div className={`px-2 py-2 gap-x-4 flex pb-7 ${callFromBoard ? "w-[calc(100vw_-_172px)]" : "w-[calc(100vw_-_558px)]"} overflow-x-auto`}>
                        {
                          item?.content?.length && item.content.map((content: any, contentIndex: number) => (
                            <React.Fragment key={contentIndex}>
                              {
                                content.isRFP &&
                                <RFPCard
                                  taskId={item.taskId}
                                  data={content}
                                  deleteItem={deleteItemModal}
                                  editItem={editItem}
                                  actions={item.actions}
                                  unPinTaskData={unPinTaskData}
                                  callFromBoard={callFromBoard}
                                  setEditorItemIsFavorite={setEditorItemIsFavorite}
                                />
                              }
                            </React.Fragment>
                          ))
                        }
                      </div>
                    </div>
                  } */}
                  {
                    (item?.isVendorVenueCard) &&
                    <div className="mt-5">
                      {
                        item?.content?.filter((ic: any) => ic.renderImages)?.length > 0 &&
                        <>
                          <ReviewSpaceTaskButton
                            taskName={item.taskName}
                            count={item?.content.filter((ic: any) => ic.renderImages)?.length || 0}
                            isCompleted={item.isTaskCompleted}
                          />
                          <div className={`px-2 py-2 gap-x-4 flex pb-7 ${callFromBoard ? "w-[calc(100vw_-_172px)]" : "w-[calc(100vw_-_558px)]"} overflow-x-auto on-hover-show-scrollbar`}>
                            {
                              item?.content?.length > 0 && item.content.map((content: any, contentIndex: number) => (
                                <React.Fragment key={contentIndex}>
                                  {
                                    content?.renderImages &&
                                    <ReviewEventVenueCard
                                      taskId={item.taskId}
                                      data={content}
                                      deleteItem={deleteItemModal}
                                      editItem={editItem}
                                      setItemIsFavorite={setItemIsFavorite}
                                      actions={item.actions}
                                      unPinTaskData={unPinTaskData}
                                      callFromBoard={callFromBoard}
                                    />
                                  }
                                </React.Fragment>
                              ))
                            }
                          </div>
                        </>
                      }
                      {
                        item?.content?.filter((ic: any) => ic.isRFP)?.length > 0 &&
                        <>
                          <ReviewSpaceTaskButton
                            taskName={'RFP'}
                            count={item?.content.filter((ic: any) => ic.isRFP).length || 0}
                            isCompleted={item.isTaskCompleted}
                          />
                          <div className={`px-2 py-2 gap-x-4 flex pb-7 ${callFromBoard ? "w-[calc(100vw_-_172px)]" : "w-[calc(100vw_-_558px)]"} overflow-x-auto on-hover-show-scrollbar`}>
                            {
                              item?.content?.length && item.content.map((content: any, contentIndex: number) => (
                                <React.Fragment key={contentIndex}>
                                  {
                                    content.isRFP &&
                                    <RFPCard
                                      taskId={item.taskId}
                                      data={content}
                                      deleteItem={deleteItemModal}
                                      editItem={editItem}
                                      actions={item.actions}
                                      unPinTaskData={unPinTaskData}
                                      callFromBoard={callFromBoard}
                                      setEditorItemIsFavorite={setEditorItemIsFavorite}
                                    />
                                  }
                                </React.Fragment>
                              ))
                            }
                          </div>
                        </>
                      }
                    </div>
                  }
                  {
                    (item?.isFileUpload) &&
                    <div className={`px-2 py-2 gap-x-4 flex pb-7 ${callFromBoard ? "w-[calc(100vw_-_172px)]" : "w-[calc(100vw_-_558px)]"} overflow-x-auto on-hover-show-scrollbar`}>
                      {
                        item?.content?.length && item.content.map((content: any, contentIndex: number) => (
                          <React.Fragment key={contentIndex}>
                            {/* Add img and pin it */}
                            <FileUploadCard
                              taskId={item.taskId}
                              data={content}
                              deleteItem={deleteItemModal}
                              editItem={editItem}
                              actions={item.actions}
                              unPinTaskData={unPinTaskData}
                              callFromBoard={callFromBoard}
                            />
                          </React.Fragment>
                        ))
                      }
                    </div>
                  }
                  {
                    (item?.isLogistics) &&
                    <div className={`px-2 py-2 gap-x-4 flex pb-7 ${callFromBoard ? "w-[calc(100vw_-_172px)]" : "w-[calc(100vw_-_558px)]"} overflow-x-auto on-hover-show-scrollbar`}>
                      {
                        item?.content?.length && item.content.map((content: any, contentIndex: number) => (
                          <React.Fragment key={contentIndex}>
                            <LogisticsCard
                              taskId={item.taskId}
                              data={content}
                              deleteItem={deleteItemModal}
                              editItem={editItem}
                              actions={item.actions}
                              unPinTaskData={unPinTaskData}
                              callFromBoard={callFromBoard}
                            />
                          </React.Fragment>
                        ))
                      }
                    </div>
                  }
                </div>
              </React.Fragment>
            ))
          }
          {
            !loading && !callFromBoard && insightData?.length == 0 && <EmptyReviewSpace cardName={selectedCardDetail?.title} />
          }
          {
            !loading && callFromBoard && insightData?.length == 0 && <EmptyReviewSpace blockName={blockName} openFeteFromBoard={openFeteFromBoard} />
          }
        </div>
      </div >
    </>
  );
};

export default ReviewSpace;
